/// <amd-module name="Wit/Common/WitSettingsViews/Components/TableStatus" />
import * as React from "react";
import { IObservableValue } from "VSS/Core/Observable";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";
import { Observer } from "VSSUI/Observer";
import { Status, Statuses, StatusSize } from "VSSUI/Status";
import { css } from "VSSUI/Util";

export interface ITableStatusProps {
    /**
     * Class to be applied to element wrapping two error message views
     */
    className?: string;
    /**
     * Error originating from failed data provider call
     */
    dataProviderErrorMessage?: IObservableValue<string | undefined>;
    /**
     * Error originating from bad user input
     */
    validationErrorMessage?: IObservableValue<string | undefined>;
}

export const TableStatus: React.FunctionComponent<ITableStatusProps> = props => {
    return (
        <div className={css("flex-column", "rhythm-vertical-16", props.className)}>
            {props.validationErrorMessage && (
                <Observer errorMessage={props.validationErrorMessage}>
                    {(observerProps: { errorMessage: string | undefined }) =>
                        observerProps.errorMessage ? (
                            <div className="flex-row flex-center rhythm-horizontal-8">
                                <Status {...Statuses.Failed} key="error" size={StatusSize.m} />
                                <span className="error-text">{observerProps.errorMessage}</span>
                            </div>
                        ) : null
                    }
                </Observer>
            )}
            {props.dataProviderErrorMessage && (
                <Observer errorMessage={props.dataProviderErrorMessage}>
                    {(props: { errorMessage: string | undefined }) =>
                        props.errorMessage ? <MessageCard severity={MessageCardSeverity.Error}>{props.errorMessage}</MessageCard> : null
                    }
                </Observer>
            )}
        </div>
    );
};
